// import { FC, ChangeEvent, useState, Fragment } from 'react';

// import {
//   Tooltip,
//   Divider,
//   Box,
//   FormControl,
//   InputLabel,
//   Card,
//   Checkbox,
//   IconButton,
//   Table,
//   TableBody,
//   TableCell,
//   TableHead,
//   TablePagination,
//   TableRow,
//   TableContainer,
//   Select,
//   MenuItem,
//   Typography,
//   useTheme,
//   CardHeader,
//   Stack,
//   TextField,
//   Button
// } from '@mui/material';

// import Label from 'src/components/Label';

// import { useNavigate } from 'react-router';

// import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
// import { formatDate } from 'src/utils/date';

// // interface RecentOrdersTableProps {
// //   className?: string;
// //   Job: Job[];
// // }

// interface Filters {
//   status;
// }

// const getStatusLabel = (Job) => {
//   const map = {
//     inComplete: {
//       text: 'In Complete',
//       color: 'primary'
//     },
//     completed: {
//       text: 'Complete',
//       color: 'success'
//     },
//     notSent: {
//       text: 'not Sent',
//       color: 'error'
//     }
//   };

//   const { text, color } = map[Job];

//   return <Label color={color}>{text}</Label>;
// };

// const applyFilters = (Job, filters) => {
//   return Job.filter((job) => {
//     let matches = true;

//     if (filters.status && job.status !== filters.status) {
//       matches = false;
//     }

//     return matches;
//   });
// };

// const applyPagination = (Job, page: number, limit: number) => {
//   return Job.slice(page * limit, page * limit + limit);
// };
// const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
// const ContractorCalendarTable = ({ Job }) => {
//   const navigate = useNavigate();
//   const [selectedCryptoOrders, setSelectedCryptoOrders] = useState([]);
//   const selectedBulkActions = selectedCryptoOrders.length > 0;
//   const [page, setPage] = useState<number>(0);
//   const [limit, setLimit] = useState<number>(10);
//   const [filters, setFilters] = useState({
//     status: null
//   });

//   const statusOptions = [
//     {
//       id: 'all',
//       name: 'All'
//     },
//     {
//       id: 'completed',
//       name: 'Complete'
//     },
//     {
//       id: 'process',
//       name: 'In Process'
//     },
//     {
//       id: 'booked',
//       name: 'Booked'
//     }
//   ];

//   const handleStatusChange = (e) => {
//     let value = null;

//     if (e.target.value !== 'all') {
//       value = e.target.value;
//     }

//     setFilters((prevFilters) => ({
//       ...prevFilters,
//       status: value
//     }));
//   };

//   const handleSelectAllCryptoOrders = (event) => {
//     setSelectedCryptoOrders(
//       event.target.checked ? Job.map((cryptoOrder) => cryptoOrder.id) : []
//     );
//   };

//   const handleSelectOneCryptoOrder = (event, cryptoOrderId) => {
//     if (!selectedCryptoOrders.includes(cryptoOrderId)) {
//       setSelectedCryptoOrders((prevSelected) => [
//         ...prevSelected,
//         cryptoOrderId
//       ]);
//     } else {
//       setSelectedCryptoOrders((prevSelected) =>
//         prevSelected.filter((id) => id !== cryptoOrderId)
//       );
//     }
//   };

//   const handlePageChange = (event, newPage: number) => {
//     setPage(newPage);
//   };

//   const handleLimitChange = (event) => {
//     setLimit(parseInt(event.target.value));
//   };

//   const filteredCryptoOrders = applyFilters(Job, filters);
//   const paginatedCryptoOrders = applyPagination(
//     filteredCryptoOrders,
//     page,
//     limit
//   );
//   const selectedSomeCryptoOrders =
//     selectedCryptoOrders.length > 0 && selectedCryptoOrders.length < Job.length;
//   const selectedAllCryptoOrders = selectedCryptoOrders.length === Job.length;
//   const theme = useTheme();

//   const [startDate, setStartDate] = useState<Date | null>(null);
//   const [endDate, setEndDate] = useState<Date | null>(null);

//   console.log({
//     startDate,
//     endDate
//   });

//   return (
//     <Fragment>
//       <Stack>
//         <TableContainer>
//           <Table>
//             <TableHead>
//               <TableRow>
//                 <TableCell>Job Number</TableCell>
//                 <TableCell>Position</TableCell>
//                 <TableCell>City</TableCell>
//                 <TableCell>State</TableCell>
//                 <TableCell>Start Date</TableCell>
//                 <TableCell>End Date</TableCell>
//                 <TableCell>Call Time Start</TableCell>
//                 <TableCell>Call Time End</TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {paginatedCryptoOrders.map((job) => {
//                 const isCryptoOrderSelected = selectedCryptoOrders.includes(
//                   job.id
//                 );
//                 return (
//                   <TableRow hover key={job.id} selected={isCryptoOrderSelected}>
//                     <TableCell>{job?.shift?.Event?.title}</TableCell>
//                     <TableCell>{job?.position}</TableCell>
//                     <TableCell>{job?.shift?.Event?.city}</TableCell>
//                     <TableCell>{job?.shift?.Event?.state}</TableCell>
//                     <TableCell>{formatDate(job?.startDate)}</TableCell>
//                     <TableCell>{formatDate(job?.endDate)}</TableCell>
//                     <TableCell>{job.startTime}</TableCell>
//                     <TableCell>{job.endTime}</TableCell>
//                   </TableRow>
//                 );
//               })}
//             </TableBody>
//           </Table>
//         </TableContainer>
//       </Stack>
//       <Box p={2}>
//         <TablePagination
//           component="div"
//           count={filteredCryptoOrders.length}
//           onPageChange={handlePageChange}
//           onRowsPerPageChange={handleLimitChange}
//           page={page}
//           rowsPerPage={limit}
//           rowsPerPageOptions={[5, 10, 25, 30]}
//         />
//       </Box>
//     </Fragment>
//   );
// };

// export default ContractorCalendarTable;

import React, { useEffect, useState } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  MenuItem,
  Select,
  IconButton,
  Box,
  ListItem,
  List,
  ListItemText,
  Typography,
  Divider,
  Card,
  Stack
} from '@mui/material';
import { ArrowBack, ArrowForward } from '@mui/icons-material';
import { useNavigate } from 'react-router';

const localizer = momentLocalizer(moment);

const ContractorCalendarTable = ({ jobs }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(moment().month());
  const [selectedYear, setSelectedYear] = useState(moment().year());
  const navigate = useNavigate();
  const [events, setEvents] = useState(jobs || []);

  useEffect(() => {
    setEvents(jobs);
  }, [jobs]);

  const handleSelectEvent = (event) => {
    setSelectedEvent(event);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedEvent([]);
  };

  const handleChangeMonth = (event) => {
    setSelectedMonth(event.target.value);
  };

  const handleChangeYear = (event) => {
    setSelectedYear(event.target.value);
  };

  const handlePreviousMonth = () => {
    if (selectedMonth === 0) {
      setSelectedMonth(11);
      setSelectedYear((prevYear) => prevYear - 1);
    } else {
      setSelectedMonth((prevMonth) => prevMonth - 1);
    }
  };

  const handleNextMonth = () => {
    if (selectedMonth === 11) {
      setSelectedMonth(0);
      setSelectedYear((prevYear) => prevYear + 1);
    } else {
      setSelectedMonth((prevMonth) => prevMonth + 1);
    }
  };

  return (
    <>
      <Box
        style={{
          position: 'relative',
          right: 0,
          // top: -25,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Typography variant="h3" sx={{ fontWeight: 'bold', ml: 2}}>
          Contractor Calendar
        </Typography>
        <Stack direction="row" spacing={1} sx={{ mb: 2,mr:2 }}>
          <Button onClick={handlePreviousMonth}>
            <ArrowBack />
            Previous Month
          </Button>
          <Button onClick={handleNextMonth}>
            Next Month
            <ArrowForward />
          </Button>
          <Select
            sx={{ width: '150px', marginRight: '10px' }}
            size="small"
            value={selectedMonth}
            onChange={handleChangeMonth}
          >
            {moment.months().map((month, index) => (
              <MenuItem key={index} value={index}>
                {month}
              </MenuItem>
            ))}
          </Select>
          <Select
            sx={{ width: '150px' }}
            size="small"
            value={selectedYear}
            onChange={handleChangeYear}
          >
            {Array.from({ length: 10 }, (_, i) => moment().year() + i).map(
              (year) => (
                <MenuItem key={year} value={year}>
                  {year}
                </MenuItem>
              )
            )}
          </Select>
        </Stack>
      </Box>

      <div
        style={{
          position: 'relative',
          // marginBottom: '30px',
          // border: '1px solid #000000',
          // boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
          // borderRadius: '8px',
          height: 'calc(100vh - 150px)', // Adjust based on your layout
          overflow: 'hidden'
        }}
      >
        <div style={{ flex: 1, height: '100%', padding: '16px' }}>
          <Calendar
            localizer={localizer}
            events={events}
            startAccessor="start"
            endAccessor="end"
            style={{ height: '100%' }}
            onSelectEvent={(e) =>
              navigate(`/dashboards/jobTracker/positions/${e.eventId}`, {
                state: { title: e.eventTitle, tab: '2' }
              })
            }
            eventPropGetter={(event) => ({
              style: event.style // Apply event-specific styles
            })}
            views={['month']}
            date={moment()
              .set('month', selectedMonth)
              .set('year', selectedYear)
              .toDate()}
            toolbar={false}
            popup
            // onShowMore={(events, date) => {
            //   const clickedDate = moment(date).format('YYYY-MM-DD');
            //   const dayEvents = events.filter(
            //     (event) =>
            //       moment(event.start).format('YYYY-MM-DD') === clickedDate
            //   );

            //   setSelectedEvent(dayEvents);
            //   setModalOpen(true);
            // }}
          />
        </div>

        <Dialog
          open={modalOpen}
          onClose={handleCloseModal}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>
            {selectedEvent.length > 0 &&
              moment(selectedEvent[0].start).format('YYYY-MM-DD')}
          </DialogTitle>
          <DialogContent>
            {selectedEvent.length > 0 ? (
              <List>
                {selectedEvent.map((event, idx) => (
                  <React.Fragment key={idx}>
                    <ListItem
                      button
                      onClick={() =>
                        navigate(
                          `/dashboards/jobTracker/positions/${event.eventId}`,
                          {
                            state: { title: event.title }
                          }
                        )
                      }
                    >
                      <ListItemText primary={event.title} />
                    </ListItem>
                    <Divider />
                  </React.Fragment>
                ))}
              </List>
            ) : (
              <Typography>No events for this day.</Typography>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseModal}>Close</Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
};

export default ContractorCalendarTable;
